import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {OrderElement} from "../../data/orderelement";
import {Store} from "@ngrx/store";
import {selectComplaintState} from "../../orders.root.state";
import {complaintActions} from "../../states/complaint/complaint.actions";
import {AsyncPipe, NgIf} from "@angular/common";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@Component({
  selector: 'cover-complaint-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    NgIf,
    AsyncPipe,
    TranslateModule
  ],
  templateUrl: './complaint-form.component.html',
  styleUrls: ['./complaint-form.component.scss']
})
export class ComplaintFormComponent {
  complaint = new FormControl("", Validators.required);
  complaintState$ = this.store.select(selectComplaintState);

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: OrderElement,
    private store: Store
  ) {}

  onRegisterComplaint() {
    this.store.dispatch(complaintActions.trySaveComplaint({
      payload: {complaint: this.complaint.value || '', order: this.data}
    }));
  }
}
